import React, { useContext, useEffect, useState } from 'react'
import { Table } from '../../../dpe-usco'
import { GlobalContext } from '../../../services/context'
import { customSort } from '../../../services/utils'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import { Button, Modal } from 'syngenta-react-components'
import LinkCompany from '../../../components/ModalForms/LinkCompany'
import HeaderFilter from '../../../components/subComponents/HeaderFilter'
import { getHighestRole, getSignerAssignments, syncCompany } from '../../../services/apiHelper'
import { useParams } from 'react-router-dom'

const CompanyAssignement = ({ assignmentData, status }) => {
  const { dispatch } = useContext(GlobalContext)
  const [showModal, setShowModal] = useState(false)
  const [assignmentDataFilter, setAssignmentDataFilter] = useState([])
  const[isChecked, setIsChecked] = useState(false)
  const[assignStatus, setAssignStatus] = useState(status)
  const [filteredSapArray, setFilteredSapArray] = useState([])
  const [synBtnTxt, setSynBtnTxt] = useState('Sync companies')
  const { user_id } = useParams() || {}

  useEffect(()=>{
    setAssignmentDataFilter(assignmentData)
  },[assignmentData])

  useEffect(()=>{
    setAssignStatus(status)
  },[status])

  const [isDealer, setIsDealer] = useState(false)
  const [isSyncCompany, setIsSyncCompany] = useState(false)

  useEffect(() => {
    getHighestRole()?.then(res => {
      if(res.permissions.includes('filter-enogen-company')){
        setIsDealer(true)
      } else{
        setIsDealer(false)
      }
    
      if(res.permissions.includes('sync-company')){
        setIsSyncCompany(true)
      } else{
        setIsSyncCompany(false)
      }
    })
  }, [])

  const acendCallBack = dataKey => {
    setAssignmentDataFilter(customSort(assignmentDataFilter, dataKey, 'asc'))
  }

  const decendCallBack = dataKey => {
    setAssignmentDataFilter(customSort(assignmentDataFilter, dataKey, 'desc'))
  }

  const headerCell = (value, dataKey = null) => {
    if(dataKey) {
      return (
        <div key={value} className="cell df aic">
          <span>{value}</span>
          <HeaderFilter
            dataKey={dataKey}
            descend={() => decendCallBack(dataKey)}
            ascend={() => acendCallBack(dataKey)}
          />
        </div>
      )
    }
    else {
      return (
        <div key={value} className='cell df aic'>
          <span>{value}</span>
        </div>
      )
    }

  }

  const structure = {
    headers: [
      {
        value: 'Company name',
        format() {
          return headerCell(this.value, 'company_name')
        }
      },
      {
        value: 'Role',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'SAP Id',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'Phone',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'Location',
        format() {
          return headerCell(this.value)
        }
      }
    ],
    dataKeys: [
      'company_name',
      'role',
      'sap_id',
      'phone',
      'location'
    ],
    rowFormat: {
      company_name: {
        format: obj => {
          return (
            <a
              href={`/company/${obj.id}`}
              className='c-blue-500 c-blue-700:h tdu:h'
              onClick={() => dispatch({ type: 'GO_COMPANY_VIEW', payload: { id: obj.id, title: obj.title, previous: 'Back'  } })}>
              {obj.title}
            </a>
          )
        }
      }
    }
  }

  const handleLinkCompanyModal = () => {
    setShowModal(true)
  }
  const handleClose = () => {
    setShowModal(false)
  }

  const checked = e => {
    setIsChecked(prev => !prev)
    if(e.target.checked){
      if(assignmentData.length > 0) {
        let filterData = []
        filterData = assignmentData.filter(x=>x.enogen_dealer === true)
        setAssignmentDataFilter(filterData)
        if(filterData.length <= 0)
          setAssignStatus('EMPTY')
        else
          setAssignStatus()
      } else {
        setAssignStatus('EMPTY')
      }
    } else {
      setAssignStatus()
      setAssignmentDataFilter(assignmentData)
    }
  }

  const handleSyncCompany = () => {
    const params = {
      sapIds: filteredSapArray
    }
    setSynBtnTxt('Sync in progress...')
    syncCompany(params).then(res => {
      if (res.status === 200) {
        setTimeout(()=> {
          setAssignStatus('LOADING')
          getSignerAssignments(user_id).then(response => {
            let updatedResponse = []
            updatedResponse = response?.map(obj => {
              return {
                ...obj,
                location: `${obj.city}, ${obj.state} `
              }
            })
            if (updatedResponse.length) {
              setAssignmentDataFilter(updatedResponse)
              setAssignStatus('null')
            } else {
              setAssignStatus('EMPTY')
            }
            setSynBtnTxt('Sync Complete')
          })
        },60000)
      }
      else {
        setSynBtnTxt('Sync Failed')
      }
    })
  }

  useEffect(()=>{
    let sapArray = []
    let sapArrayFilter = assignmentDataFilter.filter(x => x.sap_id !== 'N/A') 
    if(sapArrayFilter.length > 0) {
      sapArray = sapArrayFilter.map(el => { return el.sap_id })
    }
    setFilteredSapArray(sapArray)
  },[assignmentDataFilter])
  
  return (
    <div data-testid="tableStatusLoader">
      <Widget title='Company assignments'>
        <div className='tar'> 
          {isDealer &&
          <span>
            <input
              className="w15"
              type="checkbox"
              id="enogenDealerId"
              onChange={e => checked(e)}
              checked={isChecked}
            />
            <label htmlFor="sameHarvestDate">
              Enogen Dealer
            </label>
          </span>
          }
          {isSyncCompany &&
          <span className="ml5 pl15">      
            <Button
              text={synBtnTxt}
              clickHandler={handleSyncCompany}
              disabled={!filteredSapArray.length || synBtnTxt !== 'Sync companies'}
            />
          </span> 
          }
          <span className="ml5 pl15">      
            <Button
              text='Link company'
              clickHandler={handleLinkCompanyModal}
            />
          </span>
        </div>
        <Modal
          autoHeight
          show={showModal}
          handleClose={handleClose}
        >
          <LinkCompany
            handleCancel={handleClose}
            handleCreate={handleClose}
          />
        </Modal>
        <Table data={assignmentDataFilter} structure={structure} 
          statusComponent={
            assignStatus === 'EMPTY' ? (
              <TableStatus
                status={assignStatus}
                prompt={'No data'}
              />
            ) : null
          }
        ></Table>
      </Widget>    
    </div>
  )
}

export default CompanyAssignement